 

export default{ 
    data() {
        
        return {
            breadcrumb:[{
                name:'首页', path:'/home'
            },{
                name: '请休假列表', path:''
            },{
                name:'请休假详情', path:''
            }],
            apis:{//接口列表 
                upload: this.$global.baseUrl + 'sh/file/upload',//文件上传   
                save:'oa/official/leave/save',//保存
                bykey:'oa/official/leave/byKey',//详情  
                getWfTask:'/oa/official/getWFTask',//任务详情
                sign: 'sh/wf/task/sign', //签收任务
            }, 
            editObj:{
                title:"",  
                leaveType:'',
                scope:1
            }, 
            wfFlowModel:{
                finish:false,
                turn:false,
            },
            key:"",
            fileList:[],//源文件
            enclosureList:[],//附件 
            userWnd: false,//是否显示人员选择窗口 
            fileNumList:[],
            leadWnd:false,
            WFtask:{}, 
        }
    },
    props: {
        visible: { 
          type: Boolean,
          default: false
        }, 
        bizKey:String, 
    },
    
    watch: {
        bizKey() {
            this.find();
        }, 
    }, 
    mounted() {  
        this.find(); 
    },                               
    methods: {
        getWfTask(taskKey){ 
            this.$post({
                url: this.apis.getWfTask,
                params:taskKey,  
            }).then(rsp => {
                if(rsp.success){
                    this.WFtask = rsp.retObj; 
                    if(this.WFtask.type==2){
                        this.sign();
                    }
                }
            })
        },
        sign(){
            const me = this;
            me.$post({
                url: me.apis.sign,
                params: me.WFtask.id
            }).then(rsp => {
                if(rsp.success){ 
                    me.$message.success("签收成功");
                }
            })
        },
        find(){
            const me = this;
            me.key = me.bizKey;
            me.$post({
                url: me.apis.bykey,
                params: me.key,  
            }).then(rsp => {
                if(rsp.success){
                    me.editObj=rsp.retObj;  
                }
            })
        }, 
        
        goBack(){ 
            this.$router.go(-1);
        },   
        print(){
            let {href}  = this.$router.resolve({ path: "/oa/official/leave/print/"+this.key})
            window.open(href, '_blank')  
        }
    },
}


// WEBPACK FOOTER //
// ./src/components/oa/view/official/leave/view/view.js